<span class="input-date-component">
    <label>{{ label | translate }}</label>
    <div class="input-group content">
        <input type="hidden" [disabled]="control.disabled" (dateSelect)="dateSelect($event)" name="ds" ngbDatepicker #ds="ngbDatepicker" [firstDayOfWeek]="7" [positionTarget]="dateInput" [minDate]="minDate" [maxDate]="maxDate">
        <input type="text" class="form-control" #dateInput id="start-date" placeholder="dd/mm/yyyy" [formControl]="control" [disabled]="control.disabled" [leadZeroDateTime]="true" mask="d0/M0/0000" [dropSpecialCharacters]="false" />
        <div class="input-group-text cursor-pointer" (click)="ds.toggle()"><i class="fa fa-calendar" aria-hidden="true"></i></div>
    </div>
</span>
